import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { MenubarModule } from 'primeng/menubar';
import {
  createBackofficeRoute,
  createDashboardRoute,
  createInstallationRoute,
  createLoginRoute,
  createMonitoringRoute,
  createPermissionRoute,
  createUsersRoute,
} from '../../constants/route_generation';
import { Auth, User, UserRoles } from '../../services/auth';

@Component({
  selector: 'app-topbar-menu',
  imports: [
    MenubarModule,
    ButtonModule,
    DividerModule,
    BadgeModule,
    RouterModule,
  ],
  templateUrl: './topbar-menu.html',
  styleUrl: './topbar-menu.css',
})
export class TopbarMenu implements OnInit {
  items: MenuItem[] | undefined;
  uniqueMenubarDt = {
    border: {
      radius: '0px',
      color: 'none',
    },
  };

  homeLink: string = createDashboardRoute();
  currentUser: User | null = null;

  constructor(
    private authService: Auth,
    private router: Router,
  ) {
    this.currentUser = this.authService.getCurrentUser();
    this.buildMenu();
  }

  ngOnInit(): void {}

  private buildMenu() {
    this.items = [
      {
        label: 'All boxes',
        icon: 'pi pi-home',
        routerLink: createDashboardRoute(),
      },
      // {
      //   label: 'Projects',
      //   icon: 'pi pi-search',
      //   badge: '3',
      //   items: [
      //     {
      //       label: 'Core',
      //       icon: 'pi pi-bolt',
      //       shortcut: '⌘+S',
      //     },
      //     {
      //       label: 'Blocks',
      //       icon: 'pi pi-server',
      //       shortcut: '⌘+B',
      //     },
      //     {
      //       separator: true,
      //     },
      //     {
      //       label: 'UI Kit',
      //       icon: 'pi pi-pencil',
      //       shortcut: '⌘+U',
      //     },
      //   ],
      // },
    ];
    if (this.authService.hasRole(UserRoles.SUPER_ADMIN)) {
      this.items.splice(1, 0, {
        label: 'Backoffice',
        icon: 'pi pi-cog',
        routerLink: createBackofficeRoute(),
      });

      if (this.authService.hasRole(UserRoles.SUPER_ADMIN)) {
        this.items.push(
          {
            label: 'Users',
            icon: 'pi pi-user',
            routerLink: createUsersRoute(),
          },
          {
            label: 'Monitoring',
            icon: 'pi pi-chart-bar',
            routerLink: createMonitoringRoute(),
          },
          {
            label: 'Installations',
            icon: 'pi pi-list',
            routerLink: createInstallationRoute(),
          },
          {
            label: 'Permissions',
            icon: 'pi pi-key',
            routerLink: createPermissionRoute(),
          },
        );
      }
    }
  }

  logout() {
    this.authService.logout();
    this.router.navigate([createLoginRoute()]);
  }
}
